import { Box, Card, Text } from "@mantine/core";

import type { IconProps } from "@tabler/icons-react";
import type { FC } from "react";

interface MenuMobileCardProps {
  onClick?: () => void;
  title?: string;
  description: string;
  bg: string;
  icon: FC<IconProps>;
}

const MenuMobileCard: FC<MenuMobileCardProps> = ({
  onClick,
  title,
  description,
  bg = "secondary.5",
  icon: IconComponent,
}) => {
  const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
  const isClickable = typeof onClick === "function";

  return (
    <Card
      h="6.25em"
      w="100%"
      bdrs="md"
      bg={bg}
      p="1em"
      style={{
        cursor: isClickable ? "pointer" : "default",
        userSelect: "none",
      }}
      onClick={isClickable ? onClick : undefined}
      c="white"
    >
      <Box pos="relative" bottom="0.1em">
        <Box pos="relative" top="0.2em" left="0.0625em">
          <IconComponent />
        </Box>
        <Text fz="md" fw={500} style={{ minHeight: "1.25em" }}>
          {title ? capitalize(title) : ""}
        </Text>

        <Text fz={title ? "sm" : "md"} fw={400}>
          {description}
        </Text>
      </Box>
    </Card>
  );
};

export default MenuMobileCard;
